import { Box, Paper } from "@mui/material";
import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { useTenant } from "hooks/useTenant";
import { useThemeGreyBackgroundColor } from "hooks/useThemeGreyBackgroundColor";

import { FacilityHeaderV2 } from "./ProfileV2/FacilityHeaderV2";
import { TasksSection } from "./ProfileV2/TasksSection";
import { useFacility } from "./useFacility";

export const FacilityTasksV2: React.FC = () => {
  const greyBackgroundColor = useThemeGreyBackgroundColor();
  const { tenant } = useTenant();
  const { data } = useFacility();

  useBreadcrumb([
    {
      label: "Facilities",
      to: `/o/${tenant?.id}/facilities`,
    },
    {
      label: data?.facility?.name ?? "",
    },
  ]);

  return (
    <Box sx={{ background: greyBackgroundColor, minHeight: "100vh" }}>
      <FacilityHeaderV2 />

      <Paper elevation={0} sx={{ p: 3, m: 2 }}>
        <TasksSection />
      </Paper>
    </Box>
  );
};
